// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnswersFormController from "./answers_form_controller"
import HelloController from "./hello_controller"
import QuizController from "./quiz_controller"

application.register("answers-form", AnswersFormController)
application.register("hello", HelloController)
application.register("quiz", QuizController)
